import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_f2ec5373: FaireBrandEntity = {
  token: "b_f2ec5373",
  type: "brand",
  name: "BEE-OCH Organics",
  avatarUrl:
    "https://cdn.faire.com/fastly/b3ec40e6f81039462c79dbc66be795bdea8a1f872789c6b7e0d8d4df16234e3b.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/ed3b9d894390740ee349394b1ac89f393ba16ea85a84991c65db85989a12736c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/b3ec40e6f81039462c79dbc66be795bdea8a1f872789c6b7e0d8d4df16234e3b.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ed3b9d894390740ee349394b1ac89f393ba16ea85a84991c65db85989a12736c.jpeg",
  location: "Fort Lupton, CO, USA",
  minimumOrderDollars: 149,
  rating: 5,
  reviewCount: 248,
  isTopShop: true,
  isInsider: true,
  description:
    "BEE-OCH is a woman-owned business founded by a new mother (and then pre-med student) on a mission to rid chemicals from her family's daily use products. Finding that \"green-washing\" is a widely used practice in the beauty industry, she knew her line had to be the best of the best. BEE-OCH Organics received USDA Organic Certification in 2015 and is proud to offer 100% effective products, without the ingredient panel surprises she knows are all too common. \n\nBEE-OCH is a fun play on words, as they formulate several products with organic beeswax, but is also an acronym for BEE Original, BEE Change, BEE Heard. It serves as a reminder to girls from all walks of life that you can do anything as long as you have the passion.  \"Walking into my college professors office 5 months pregnant and being told 'no' for a letter of recommendation into medical school because of 'life circumstances' still plays back in my head, and still drives me to this day.\"-Brooke, Owner/Founder\n\nThey offer free shelf-talkers with every product carried, and are always available to answer any questions you or your customers might have. Now shipping with 100% plastic-free and recycled wrapping!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:49.957Z",
    importedBy: "entity-db-cli",
  },
};
